import React from 'react'

export default function FaceFeature({ scaleX, fill, outline, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`} fill="none">
      <path
        d="M17.9821 4.88731C17.9821 4.88731 20.3221 1.80731 23.8421 2.57731C27.1521 3.29731 27.692 5.05732 30.782 5.76732C34.042 6.52732 35.132 3.78734 35.132 3.78734C35.132 3.78734 34.522 8.57732 29.632 9.61732C24.432 10.7273 18.2421 7.63731 18.2421 7.63731L17.9921 7.46733L17.7421 7.63731C17.7421 7.63731 11.5421 10.7273 6.35205 9.61732C1.45205 8.56732 0.852051 3.78734 0.852051 3.78734C0.852051 3.78734 1.95204 6.59732 5.20204 5.76732C8.01204 5.05732 9.27205 2.62733 12.472 2.40733C15.982 2.16733 17.9821 4.88731 17.9821 4.88731Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M2.32178 6.47734C5.73178 8.23734 8.87177 5.15736 12.4518 4.87736C15.1018 4.67736 17.5718 5.97734 17.5718 5.97734C17.5718 5.97734 9.64178 9.55736 3.04178 7.02736"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M33.6421 6.47734C30.2321 8.23734 27.0921 5.15736 23.5121 4.87736C20.8621 4.67736 18.3921 5.97734 18.3921 5.97734C18.3921 5.97734 26.3221 9.55736 32.9221 7.02736"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M0.751999 0.917236C0.751999 0.917236 -1.148 3.97725 1.442 7.21725L3.09201 5.04724C3.09201 5.04724 1.192 4.33724 0.751999 0.917236Z"
        fill={outline}
      />
      <path
        d="M35.192 0.917236C35.192 0.917236 37.092 3.97725 34.502 7.21725L32.8521 5.04724C32.8621 5.04724 34.752 4.33724 35.192 0.917236Z"
        fill={outline}
      />
    </g>
  )
}
